// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__HjQDG","pageChange":"Paginator_pageChange__27GN3"};